const VipType = {
  Consumer: "consumer",
  Rides: "rides",
  Biz: "biz",
  BizPlus: "biz-plus",
  BizMax: "biz-max",
  Public: "public",
};

export default VipType;
